import React, { FC } from 'react';

interface CombineProviderProps {
    children: React.ReactNode;
}

export const combineProviders = (
    // biome-ignore lint/suspicious/noExplicitAny: legacy
    ...providers: any[]
): FC<CombineProviderProps> =>
    providers.reverse().reduce(
        (AccumulatedComponents, { Provider, props }) =>
            ({ children }: { children: React.ReactNode }): JSX.Element => (
                <AccumulatedComponents>
                    <Provider {...props}>{children}</Provider>
                </AccumulatedComponents>
            ),
        ({ children }: { children: React.ReactNode }) => <>{children}</>,
    );
